module.exports = {
    prefix: 'https://tmapi.csjywlkj.cn/',
    prefix_dev: 'https://ttapiend.csjywlkj.cn/', // 测试服

    // 接口请求相关
    userBasicData: 'user/basic-data',
    userFinance: 'user/user-finance',

    userWithdrawList: 'user-withdraw/withdraw-list',
    userBankSetBank: 'user-bank/set-bank',
    userBankSetAlipay: 'user-bank/set-alipay',
    userBankMyBank: 'user-bank/my-bank',  // 银行卡信息
    userBankMyAlipay: 'user-bank/my-alipay',  // 支付宝信息
    userBankGetPassword: 'user-bank/get-password',  // 提现密码相关
    userBankSetPassword: 'user-bank/set-password',  // 设置提现密码

    userWithdrawStart: 'user-withdraw/start-withdraw',

    loginSMS: 'login/sms',
    userVerifyPhoneSMS: 'user/verify-phone-sms',

    userDebtBillList: 'user/debt-bill-list',  // 用户账单列表
    userDebtBillRepay: 'user/debt-bill-repay',  // 用户账单-还款

    webRoomInfo: 'web/room-info',  // web页面获取房间信息
}